import React from 'react'
import styles from "./styles.modules.scss"

function Modal({
  display = false,  
  modalClass,
  modalContentClass,
  modalStyle,
  width,
  height,
  closeButton = true,
  closeButtonStyle,
  closeFunction,
  children
}) {

  return (
      display &&
        <div className={`${styles.modal} ${modalClass}`}>
          <div className={`${styles.modalContent} ${modalContentClass}`} style={{ ...modalStyle, width, height}}>
            {closeButton && 
              <div>
                <span style={{...closeButtonStyle, zIndex: "99"}} title="Fechar" onClick={closeFunction} className={styles.close}>&times;</span>
              </div>
            }
            {children}
          </div>
        </div>  
  )

}

export default Modal;